import { render, staticRenderFns } from "./menu-item.vue?vue&type=template&id=71d76f07&scoped=true&"
import script from "./menu-item.vue?vue&type=script&lang=ts&"
export * from "./menu-item.vue?vue&type=script&lang=ts&"
import style0 from "./menu-item.vue?vue&type=style&index=0&id=71d76f07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d76f07",
  null
  
)

export default component.exports